import React from 'react'

const SvgHierarchy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M10 2.667c0-.369.299-.667.667-.667h2.666c.369 0 .667.298.667.667v2.666a.667.667 0 01-.667.667h-2.666A.667.667 0 0110 5.333V2.667zM2.667 18.666c0-.368.298-.666.667-.666H6c.368 0 .667.298.667.666v2.667A.667.667 0 016 22H3.334a.667.667 0 01-.667-.667v-2.666zM10 18.666c0-.368.299-.666.667-.666h2.667c.368 0 .666.298.666.666v2.667a.667.667 0 01-.666.667h-2.667a.667.667 0 01-.667-.667v-2.666zM17.333 18.666c0-.368.299-.666.667-.666h2.667c.368 0 .666.298.666.666v2.667a.667.667 0 01-.666.667H18a.667.667 0 01-.667-.667v-2.666z' />
    <path d='M11 6V4.666a1 1 0 112 0V6h-2zM11 8h2v3.666h6.333a1 1 0 011 1V16h-2v-2.334H13V16h-2v-2.334H5.666V16h-2v-3.334a1 1 0 011-1H11V8z' />
  </svg>
)

export default SvgHierarchy
